module.exports = __webpack_public_path__ + "img/fuwu1.edb76d98.png";